import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-usuario-nao-encontrado',
  templateUrl: './usuario-nao-encontrado.component.html',
  styleUrls: ['../../juridico.component.css']
})
export class UsuarioNaoEncontradoComponent implements OnInit {

  constructor(private meta: Meta) {
    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Usuário não encontrado!'
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Gerencie todo o seu processo de recrutamento e seleção em uma única plataforma. Reachr, a solução prática e inteligente de recrutamento digital.'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'vagas de emprego, oportunidade de trabalho, agencia de emprego, vagas, emprego, vaga de emprego, trabalhe conosco comunidade de emprego,'
    // });
  }

  ngOnInit(): void {
    setTimeout(() => {
        window.location.href = 'https://www.reachr.com.br/';
    }, 5000);
  }

}
